'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var abortSignal = require('../lib/abort-signal.js');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var cid = require('multiformats/cid');

var createImport = configure.configure(function (api) {
  function dagImport(_x) {
    return _dagImport.apply(this, arguments);
  }

  function _dagImport() {
    _dagImport = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(source) {
      var options,
          controller,
          signal,
          _ref,
          headers,
          body,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          _value2,
          Root,
          Cid,
          PinErrorMsg,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              controller = new AbortController();
              signal = abortSignal.abortSignal(controller.signal, options.signal);
              _context.next = 5;
              return _awaitAsyncGenerator(multipartRequest.multipartRequest(source, controller, options.headers));

            case 5:
              _ref = _context.sent;
              headers = _ref.headers;
              body = _ref.body;
              _context.next = 10;
              return _awaitAsyncGenerator(api.post('dag/import', {
                signal: signal,
                headers: headers,
                body: body,
                searchParams: toUrlSearchParams.toUrlSearchParams({
                  'pin-roots': options.pinRoots
                })
              }));

            case 10:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 13;
              _iterator = _asyncIterator(res.ndjson());

            case 15:
              _context.next = 17;
              return _awaitAsyncGenerator(_iterator.next());

            case 17:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 21;
              return _awaitAsyncGenerator(_step.value);

            case 21:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 31;
                break;
              }

              _value2 = _value, Root = _value2.Root;

              if (!(Root !== undefined)) {
                _context.next = 28;
                break;
              }

              Cid = Root.Cid['/'], PinErrorMsg = Root.PinErrorMsg;
              _context.next = 28;
              return {
                root: {
                  cid: cid.CID.parse(Cid),
                  pinErrorMsg: PinErrorMsg
                }
              };

            case 28:
              _iteratorNormalCompletion = true;
              _context.next = 15;
              break;

            case 31:
              _context.next = 37;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](13);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 37:
              _context.prev = 37;
              _context.prev = 38;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 42;
                break;
              }

              _context.next = 42;
              return _awaitAsyncGenerator(_iterator.return());

            case 42:
              _context.prev = 42;

              if (!_didIteratorError) {
                _context.next = 45;
                break;
              }

              throw _iteratorError;

            case 45:
              return _context.finish(42);

            case 46:
              return _context.finish(37);

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 33, 37, 47], [38,, 42, 46]]);
    }));
    return _dagImport.apply(this, arguments);
  }

  return dagImport;
});
exports.createImport = createImport;